import CustomComponent from '../CustomComponent';

const decodeHtmlEntities = (value) => {
	if (!value || !value.includes('&')) return value;
	const el = document.createElement('textarea');
	el.innerHTML = value;
	return el.value;
};

const parseTags = (tagsAttr) => {
	if (!tagsAttr) return [];
	try {
		return JSON.parse(decodeHtmlEntities(tagsAttr));
	} catch {
		return [];
	}
};

const renderTag = ({ label = '', type = 'success', labelPrefix = '' }) => {
	const prefix = labelPrefix ? `${labelPrefix} ` : '';
	return `<div class="lta-tag lta-tag--${type} lta-tag__wrapper">${prefix}${label}</div>`;
};

export class SpotlightCardComponent extends CustomComponent {
	static key = 'lta-spotlight-card';

	static get observedAttributes() {
		return [
			'headline',
			'subtitle',
			'text',
			'tags',
			'link',
			'bg-color',
			'image-src',
			'classes',
			'image-position',
			'info-icon',
			'size',
			'show-view-button',
			'full-height',
			'image-classes',
			'text-classes',
			'headline-classes',
			'info-classes',
			'hide-arrow'
		];
	}

	style() {
		return `
			:host {
				display: block;
				width: 100%;
			}
		`;
	}

	render() {
		const {
			headline = '',
			subtitle = '',
			text = '',
			tags = '[]',
			link = '#',
			bgColor = 'u-bg-lta-accent-purple',
			imageSrc = '',
			classes = '',
			imagePosition = '',
			infoIcon = 'false',
			size = '',
			showViewButton = 'false',
			fullHeight = 'false',
			imageClasses = '',
			textClasses = '',
			headlineClasses = '',
			infoClasses = '',
			hideArrow = 'false'
		} = this.props;

		const parsedTags = parseTags(tags);
		const sizeClass = size ? `is-${size}` : '';
		const backgroundPositionClass = imagePosition ? `has-position-${imagePosition}` : '';
		const heightClass = fullHeight === 'true' ? 'has-full-height' : '';
		const classNames = ['lta-spotlight-card', bgColor, classes, sizeClass].filter(Boolean).join(' ');
		const infoClassList = ['lta-spotlight-card__info', infoClasses || 'sm:u-p-3 md:u-p-4']
			.filter(Boolean)
			.join(' ');
		const headlineClassList = ['lta-spotlight-card__headline', headlineClasses].filter(Boolean).join(' ');
		const textClassList = ['lta-spotlight-card__text', 'u-mt-1', textClasses].filter(Boolean).join(' ');
		const imageClassList = ['lta-spotlight-card__image', backgroundPositionClass, imageClasses, heightClass]
			.filter(Boolean)
			.join(' ');
		const shouldHideArrow = hideArrow === 'true' || hideArrow === true;
		const hasInfoIcon = infoIcon === 'true' || infoIcon === true;
		const hasViewButton = showViewButton === 'true' || showViewButton === true;

		const renderInfoIcon = () =>
			`<div class="sm:u-hidden lta-spotlight-card__info-icon md:u-block"><lta-icon sprite-icon="info"></lta-icon></div>`;

		const renderTags = () =>
			parsedTags.length > 0
				? `<div class="lta-spotlight-card__tags">${parsedTags.map(renderTag).join('')}</div>`
				: '';

		const renderSubtitle = () => {
			if (!subtitle) return '';
			const subtitleClass = hasInfoIcon
				? 'lta-spotlight-card__info-icon-sub-title u-mb-1'
				: 'lta-spotlight-card__subtitle u-mb-1';
			return `<p class="${subtitleClass}">${subtitle}</p>`;
		};

		const renderArrow = () =>
			`<span class="lta-spotlight-card__right-arrow" aria-hidden="true"><lta-icon sprite-icon="caret-down-fill"></lta-icon></span>`;

		const renderViewButton = () =>
			`<lta-button label="view" size="sm" classes="u-mt-2 md:u-px-7 md:u-py-1 sm:u-hidden md:u-block lta-spotlight-card__button"></lta-button>`;

		const renderImage = () =>
			imageSrc ? `<div class="${imageClassList}" style="background-image: url(${imageSrc})"></div>` : '';

		return `
			<a href="${link}" class="${classNames}" role="article" aria-label="${headline}"${text ? ` aria-description="${text}"` : ''}>
				<div class="${infoClassList}">
					${hasInfoIcon ? renderInfoIcon() : ''}
					${renderTags()}
					${renderSubtitle()}
					<p class="${headlineClassList}">
						${headline}${!shouldHideArrow ? ` ${renderArrow()}` : ''}
					</p>
					${text ? `<p class="${textClassList}">${text}</p>` : ''}
					${hasViewButton ? renderViewButton() : ''}
				</div>
				${renderImage()}
			</a>
		`;
	}
}

export default SpotlightCardComponent;
